import { selectWidgetId } from '@/context/display';
import { store } from '@/context/store';

export interface IApplyBillingContext {
    service: 'APPLY';
    apply: {
        partnerId: string | null;
        applicationId: string | null;
        widgetId: string | null;
    };
}

/**
 * Build the billing context payload to send to apply's backend.
 * Backend `resolveBillingContext` will enrich this with brandId / organisationId / managePartnerId
 * before forwarding to central-station.
 *
 * Usage:
 *   const billingContext = buildBillingContext();
 *   const response = await postUrl('/api/.../...', { ..., billingContext });
 */
export function buildBillingContext(): IApplyBillingContext {
    const state = store.getState();
    const partnerId = state.displayReducer.partner.id;
    const applicationId =
        state.borrowerReducer.application.applicationId ||
        state.borrowerReducer.application.id;
    const widgetId = selectWidgetId(state);

    return {
        service: 'APPLY',
        apply: {
            partnerId: partnerId ?? null,
            applicationId: applicationId ?? null,
            widgetId,
        },
    };
}
